import Quiz from "../../../components/test/Quiz/Quiz";
import "./layout.css";
const QuizPage = () => {
  return (
    <div className="quiz-page">
      <Quiz />
    </div>
  );
};

export default QuizPage;
